import { useEffect, useRef } from 'react';
import { getConsentStatus } from '@/components/CookieConsent';

export function GoogleAnalytics({ gaId }) {
  var injectedRef = useRef(false);

  useEffect(function () {
    function tryInject() {
      if (injectedRef.current) return;
      var consent = getConsentStatus();
      if (consent !== 'accepted' || !gaId) return;

      injectedRef.current = true;

      var script = document.createElement('script');
      script.async = true;
      script.src = 'https://www.googletagmanager.com/gtag/js?id=' + gaId;
      document.head.appendChild(script);

      var inline = document.createElement('script');
      inline.textContent =
        "window.dataLayer=window.dataLayer||[];function gtag(){dataLayer.push(arguments);}gtag('js',new Date());gtag('config','" +
        gaId +
        "');";
      document.head.appendChild(inline);
    }

    tryInject();

    window.addEventListener('cookie_consent_change', tryInject);
    return function () {
      window.removeEventListener('cookie_consent_change', tryInject);
    };
  }, [gaId]);

  return null;
}
